import React from "react";
import styled from "styled-components";

const HOURS = Array.from({ length: 25 }, (_, i) => i); // 0 ~ 24
const MINUTES = ["00", "10", "20", "30", "40", "50"];

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

const Sel = styled.select<{ $height: number }>`
  height: ${({ $height }) => $height}px;
  flex: 1;
  min-width: 0;
  padding: 0 4px;
  border: 1.5px solid #e8e8e8;
  border-radius: 8px;
  font-size: 13px;
  color: #111;
  background-color: #fafafa;
  cursor: pointer;
  transition: border-color 0.15s;

  &:focus {
    outline: none;
    border-color: #1fbc70;
    background-color: #fff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Sep = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #aaa;
  flex-shrink: 0;
`;

interface Props {
  value: string; // "HH:MM"
  onChange: (value: string) => void;
  height?: number;
}

const TimeSelect: React.FC<Props> = ({ value, onChange, height = 36 }) => {
  const [hStr, mStr] = value ? value.split(":") : ["", "00"];
  const hour = hStr !== "" && hStr !== undefined ? parseInt(hStr, 10) : NaN;
  const minute = mStr ?? "00";

  const handleHour = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const h = e.target.value;
    const m = h === "24" ? "00" : minute;
    onChange(`${String(h).padStart(2, "0")}:${m}`);
  };

  const handleMinute = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const h = !isNaN(hour) ? String(hour).padStart(2, "0") : "00";
    onChange(`${h}:${e.target.value}`);
  };

  return (
    <Wrap>
      <Sel $height={height} value={!isNaN(hour) ? hour : ""} onChange={handleHour}>
        <option value="">--</option>
        {HOURS.map((h) => (
          <option key={h} value={h}>
            {String(h).padStart(2, "0")}
          </option>
        ))}
      </Sel>
      <Sep>:</Sep>
      <Sel
        $height={height}
        value={minute}
        onChange={handleMinute}
        disabled={hour === 24}
      >
        {MINUTES.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </Sel>
    </Wrap>
  );
};

export default TimeSelect;
